export default __webpack_public_path__ + "static/media/prevIcon.c914f1dc.svg";